import React from 'react'

import AlertCard from '../../../../components/Mantine/AlertCard'

import * as S from './styles.js'

export default function Alerta({ showAlertPlan }) {
  return (
    <S.AlertaReposicaoWrapper>
      {showAlertPlan && (
        <AlertCard
          type="warning"
          message={
            <S.AlertPlanoContainer>
              <span>
                <b>Cliente VIVO 2G</b> não será mais possível realizar pedidos
                de reposições de linhas 2G. Novas ativações e pedidos de
                reposição de linhas serão apenas com a tecnologia 4G.
              </span>
            </S.AlertPlanoContainer>
          }
        />
      )}
      <AlertCard
        type="warning"
        message={
          <S.AlertPlanoContainer>
            <span>
              Prezado cliente, para tornar nosso processo de reposição mais ágil
              e seguro, ela deve ser feita com operadoras e planos já ativos no
              seu parque. Caso não localize o plano desejado, nossa equipe de
              logística está à disposição para ajudar pelo telefone (51)
              3562-1777.
            </span>
          </S.AlertPlanoContainer>
        }
      />
    </S.AlertaReposicaoWrapper>
  )
}
